/* ============================================
   ANTI FRAUD CLUB — Theme JavaScript
   AJAX Cart Drawer + Conversion Features
   ============================================ */

(function() {
  'use strict';

  /* ============================================
     UTILITIES
     ============================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ============================================
     CART DRAWER
     ============================================ */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var closeBtn = document.querySelector('[data-cart-close]');
  var cartBody = document.querySelector('[data-cart-items]');
  var cartEmpty = document.querySelector('[data-cart-empty]');
  var cartFooter = document.querySelector('[data-cart-footer]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');
  var cartSubtotalEl = document.querySelector('[data-cart-subtotal]');
  var cartCheckoutTotal = document.querySelector('[data-cart-checkout-total]');
  var cartUpsell = document.querySelector('[data-cart-upsell]');

  function openDrawer() {
    if (!drawer) return;
    fetchAndRenderCart();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Cart icon opens drawer instead of navigating
  document.querySelectorAll('a[href="/cart"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  });

  /* --- Fetch cart and render --- */
  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  function renderCart(cart) {
    // Update all count badges
    cartCountEls.forEach(function(el) { el.textContent = cart.item_count; });

    // Update header cart count badge
    var headerCount = document.querySelector('.header__cart-count');
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    if (cart.item_count === 0) {
      if (cartBody) cartBody.style.display = 'none';
      if (cartEmpty) cartEmpty.style.display = 'block';
      if (cartFooter) cartFooter.style.display = 'none';
      if (cartUpsell) cartUpsell.style.display = 'none';
      return;
    }

    if (cartBody) cartBody.style.display = 'block';
    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = 'block';
    if (cartUpsell) cartUpsell.style.display = 'block';

    // Render items
    if (cartBody) {
      var html = '';
      cart.items.forEach(function(item) {
        var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x200$1') : '';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        html += '<div class="cart-drawer__item" data-cart-item data-line-key="' + item.key + '">';
        html += '  <a href="' + item.url + '" class="cart-drawer__item-img-wrap">';
        if (imgSrc) html += '    <img src="' + imgSrc + '" alt="' + item.title + '" class="cart-drawer__item-img" loading="lazy">';
        html += '  </a>';
        html += '  <div class="cart-drawer__item-info">';
        html += '    <a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>';
        if (variantTitle) html += '    <div class="cart-drawer__item-variant">' + variantTitle + '</div>';
        html += '    <div class="cart-drawer__item-bottom">';
        html += '      <div class="cart-drawer__qty">';
        html += '        <button class="cart-drawer__qty-btn" data-drawer-minus="' + item.key + '">−</button>';
        html += '        <span class="cart-drawer__qty-num" data-drawer-qty="' + item.key + '">' + item.quantity + '</span>';
        html += '        <button class="cart-drawer__qty-btn" data-drawer-plus="' + item.key + '">+</button>';
        html += '      </div>';
        html += '      <div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
        html += '    </div>';
        html += '  </div>';
        html += '  <button class="cart-drawer__item-remove" data-drawer-remove="' + item.key + '" aria-label="Remove">';
        html += '    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        html += '  </button>';
        html += '</div>';
      });
      cartBody.innerHTML = html;
      bindCartItemEvents();
    }

    // Update totals
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
    if (cartCheckoutTotal) cartCheckoutTotal.textContent = formatMoney(cart.total_price);

    // Fetch and render upsell recommendations
    renderUpsells(cart);
  }

  /* --- Upsell Recommendations --- */
  function renderUpsells(cart) {
    var upsellItems = document.querySelector('[data-cart-upsell-items]');
    if (!upsellItems || !cartUpsell) return;

    // Get product IDs already in cart
    var cartProductIds = cart.items.map(function(item) { return item.product_id; });

    if (cartProductIds.length === 0) {
      cartUpsell.style.display = 'none';
      return;
    }

    // Use the first cart item to get recommendations
    var firstProductId = cartProductIds[0];

    fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=10')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) {
          cartUpsell.style.display = 'none';
          return;
        }

        // Filter out products already in cart, limit to 3
        var suggestions = data.products.filter(function(p) {
          return cartProductIds.indexOf(p.id) === -1 && p.available;
        }).slice(0, 3);

        if (suggestions.length === 0) {
          cartUpsell.style.display = 'none';
          return;
        }

        var html = '';
        suggestions.forEach(function(product) {
          var imgSrc = product.featured_image ? product.featured_image.replace(/(\.[^.]+)$/, '_128x128_crop_center$1') : '';
          var variantId = product.variants[0].id;
          var price = product.price;
          var hasVariants = product.variants.length > 1;

          html += '<div class="cart-drawer__upsell-item">';
          html += '  <a href="' + product.url + '" class="cart-drawer__upsell-img-wrap">';
          if (imgSrc) html += '    <img src="' + imgSrc + '" alt="' + product.title + '" class="cart-drawer__upsell-img" loading="lazy">';
          html += '  </a>';
          html += '  <div class="cart-drawer__upsell-info">';
          html += '    <a href="' + product.url + '" class="cart-drawer__upsell-name">' + product.title + '</a>';
          html += '    <div class="cart-drawer__upsell-price">' + formatMoney(price) + '</div>';
          html += '  </div>';

          if (hasVariants) {
            html += '  <a href="' + product.url + '" class="cart-drawer__upsell-add">View</a>';
          } else {
            html += '  <button class="cart-drawer__upsell-add" data-upsell-add="' + variantId + '">+ Add</button>';
          }

          html += '</div>';
        });

        upsellItems.innerHTML = html;
        cartUpsell.style.display = 'block';

        // Bind upsell add buttons
        document.querySelectorAll('[data-upsell-add]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var vid = this.dataset.upsellAdd;
            var self = this;
            self.textContent = '...';
            self.disabled = true;

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              self.textContent = '✓';
              fetchAndRenderCart();
            })
            .catch(function() {
              self.textContent = '+ Add';
              self.disabled = false;
            });
          });
        });
      })
      .catch(function() {
        cartUpsell.style.display = 'none';
      });
  }

  /* --- Cart item events (qty +/-, remove) --- */
  function bindCartItemEvents() {
    document.querySelectorAll('[data-drawer-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.drawerMinus;
        var qtyEl = document.querySelector('[data-drawer-qty="' + key + '"]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        updateCartItem(key, Math.max(0, qty - 1));
      });
    });
    document.querySelectorAll('[data-drawer-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.drawerPlus;
        var qtyEl = document.querySelector('[data-drawer-qty="' + key + '"]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        updateCartItem(key, qty + 1);
      });
    });
    document.querySelectorAll('[data-drawer-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(this.dataset.drawerRemove, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCart(cart); })
    .catch(function(err) { console.error('Cart update error:', err); });
  }

  /* --- AJAX Add to Cart (intercept all add-to-cart forms) --- */
  function interceptAddToCartForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      // Skip if already bound
      if (form.dataset.ajaxBound) return;
      form.dataset.ajaxBound = 'true';

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = this.querySelector('button[type="submit"]');
        var formData = new FormData(this);

        if (btn) {
          var originalHTML = btn.innerHTML;
          btn.innerHTML = 'Adding...';
          btn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(function(r) { return r.json(); })
          .then(function(item) {
            btn.innerHTML = '✓ Added!';
            // Close any open size picker
            document.querySelectorAll('[data-size-picker].is-open').forEach(function(p) {
              p.classList.remove('is-open');
            });
            // Open cart drawer
            openDrawer();
            // Reset button after delay
            setTimeout(function() {
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }, 1500);
          })
          .catch(function(err) {
            console.error('Add to cart error:', err);
            btn.innerHTML = 'Error';
            setTimeout(function() {
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }, 1500);
          });
        }
      });
    });
  }

  // Bind on page load
  interceptAddToCartForms();

  // Re-bind after any dynamic content changes (MutationObserver)
  var bodyObserver = new MutationObserver(function() { interceptAddToCartForms(); });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  /* ============================================
     MOBILE NAVIGATION
     ============================================ */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', function() {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* --- Mobile Nav Dropdown Toggles --- */
  document.querySelectorAll('[data-mobile-dropdown-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = this.closest('.mobile-nav__group');
      if (group) group.classList.toggle('is-open');
    });
  });

  /* ============================================
     PRODUCT CARD SIZE PICKER
     ============================================ */
  document.querySelectorAll('[data-size-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var picker = this.closest('[data-size-picker]');
      document.querySelectorAll('[data-size-picker].is-open').forEach(function(p) {
        if (p !== picker) p.classList.remove('is-open');
      });
      if (picker) picker.classList.toggle('is-open');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-size-picker]')) {
      document.querySelectorAll('[data-size-picker].is-open').forEach(function(p) {
        p.classList.remove('is-open');
      });
    }
  });

  /* ============================================
     PRODUCT PAGE — Accordion, Gallery, Variants
     ============================================ */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item = this.closest('[data-accordion-item]');
      if (item) item.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-thumb]').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = this.dataset.fullSrc;
      var mainImage = document.querySelector('[data-main-image]');
      if (mainImage && src) mainImage.src = src;
      document.querySelectorAll('[data-thumb]').forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* ============================================
     PRODUCT PAGE — Variant Selector
     Reads variant JSON, maps selected options to variant ID
     ============================================ */
  var variantsJson = document.querySelector('[data-product-variants]');
  var productVariants = [];
  if (variantsJson) {
    try { productVariants = JSON.parse(variantsJson.textContent); } catch(e) {}
  }

  function getSelectedOptions() {
    var options = [];
    document.querySelectorAll('[data-variant-group]').forEach(function(group) {
      var selected = group.querySelector('[data-variant-option].is-selected');
      if (selected) {
        options.push(selected.dataset.optionValue);
      }
    });
    return options;
  }

  function findVariant(selectedOptions) {
    for (var i = 0; i < productVariants.length; i++) {
      var v = productVariants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (v.options[j] !== selectedOptions[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariantSelection() {
    var selectedOptions = getSelectedOptions();
    var variant = findVariant(selectedOptions);
    var variantInput = document.querySelector('[data-selected-variant]');
    var priceEl = document.querySelector('[data-atc-price]');
    var mainBtn = document.getElementById('main-atc-btn');

    if (variant) {
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (mainBtn) {
        mainBtn.disabled = !variant.available;
        if (!variant.available) {
          mainBtn.innerHTML = 'Sold Out';
        } else {
          mainBtn.innerHTML = 'Add to Cart — <span data-atc-price>' + formatMoney(variant.price) + '</span>';
        }
      }
    }
  }

  document.querySelectorAll('[data-variant-option]').forEach(function(option) {
    option.addEventListener('click', function() {
      if (this.classList.contains('is-unavailable')) return;
      var group = this.closest('[data-variant-group]');
      if (group) {
        group.querySelectorAll('[data-variant-option]').forEach(function(o) {
          o.classList.remove('is-selected');
        });
      }
      this.classList.add('is-selected');
      updateVariantSelection();
    });
  });

  /* --- Quantity Selector (product page) --- */
  document.querySelectorAll('[data-quantity-minus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('[data-quantity-input]');
      if (input) {
        var val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
      }
    });
  });
  document.querySelectorAll('[data-quantity-plus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('[data-quantity-input]');
      if (input) {
        var val = parseInt(input.value, 10);
        input.value = val + 1;
      }
    });
  });

  /* ============================================
     STICKY ADD-TO-CART BAR (mobile)
     ============================================ */
  var stickyAtc = document.getElementById('sticky-atc');
  var mainAtcBtn = document.getElementById('main-atc-btn');

  if (stickyAtc && mainAtcBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyAtc.classList.remove('is-visible');
          document.body.classList.remove('has-sticky-atc');
        } else {
          stickyAtc.classList.add('is-visible');
          document.body.classList.add('has-sticky-atc');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainAtcBtn);
  }

})();
